import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const BreadCrumbsContainer = styled('div')(() => css``);
